const LIVE_HOST = {
  dev: "ke-dev.huaban.com",
  fat: "ke-fat.huaban.com",
  stage: "ke-stage.huaban.com",
  prod: "ke.huaban.com",
};

const MOBILE_HOST = {
  dev: "m-dev.huaban.com",
  fat: "m-fat.huaban.com",
  stage: "m-stage.huaban.com",
  prod: "m.huaban.com",
};

const env = process.env.NEXT_PUBLIC_DEPLOY_ENV || "prod";
export const liveHost = LIVE_HOST[env];
export const mobileHost = MOBILE_HOST[env];
